import renderXy from './xySeries';
import {MarkRenderer} from '../types';

const renderBar: MarkRenderer = (cube, spec, ctx) => ({
    type: 'highcharts',
    options: renderXy('bar', cube, spec, ctx),
});

export default renderBar;
